module.exports = __webpack_public_path__ + "static/media/navbarLogo.7741fa39.png";